import React from 'react';
import { Button } from 'react-admin';
import makeStyles from '@material-ui/core/styles/makeStyles';
import cx from 'classnames';
import SkipNextIcon from '@material-ui/icons/SkipNext';

const useStyles = makeStyles((theme) => ({
  warning: {
    color: theme.palette.warning.main,
  },
  red: {
    color: theme.palette.error.main,
  },
}));

interface Props {
  onClick?: () => void;
  warning?: boolean;
  red?: boolean;
  label?: string;
  [x: string]: any;
}

const SkipButton = (props: Props) => {
  const { onClick, warning, red, label, ...rest } = props;
  const classes = useStyles();

  return (
    <Button
      label={label || `components.ra.fields.SkipButton`}
      className={cx({ [classes.warning]: warning, [classes.red]: red })}
      onClick={onClick}
      {...rest}
    >
      <SkipNextIcon />
    </Button>
  );
};

export default SkipButton;
